"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhasedUseCase = void 0;
class PhasedUseCase {
    /**
     * Identifier used by subclasses to label metrics/logging.
     * Defaults to the runtime class name; override to pin a stable identifier
     * (e.g. against future build-time name mangling).
     */
    get useCaseName() {
        return this.constructor.name;
    }
    /**
     * Hook for wrapping a phase (e.g. with timing/memory instrumentation).
     * Default is pass-through; override in a subclass to add measurement.
     */
    async _runPhase(_phase, _input, run) {
        return await run();
    }
}
exports.PhasedUseCase = PhasedUseCase;
